import { Checkbox, Link, Typography } from '@branchjs/neo-components';
import { FormHelperText } from '@mui/material';
import React from 'react';
import { LEGAL_PRIVACY_POLICY_LINK, LEGAL_TERMS_CONDITIONS_LINK } from '../../../common/support/gdprConstants';
import { useStyles } from './TermsAndConditions.styles';
import type { TermsAndConditionsProps } from './TermsAndConditionsProps.type';

export function TermsAndConditions({
  onToggleTerms,
  showRequiredAsterisk,
  className,
  termsAccepted = false,
  showErrorText = false,
}: TermsAndConditionsProps) {
  const styles = useStyles();

  const handleToggleTerms = () => {
    onToggleTerms(!termsAccepted);
  };

  return (
    <div className={className}>
      {showRequiredAsterisk && <span className={styles.required}>*</span>}
      <Checkbox checked={termsAccepted} onChange={handleToggleTerms} id="terms-checkbox" color="primary" />
      <label htmlFor="terms">
        <Typography variant="body2">
          I agree to Branch's{' '}
          <Link href={LEGAL_TERMS_CONDITIONS_LINK} id="terms-and-conditions-link">
            Terms & Conditions
          </Link>{' '}
          and{' '}
          <Link href={LEGAL_PRIVACY_POLICY_LINK} id="privacy-policy-link">
            Privacy Policy
          </Link>
          .
        </Typography>
      </label>
      {showErrorText && (
        <FormHelperText className={styles.errorText} id="terms-error-message" error data-testid="terms-error">
          Please accept the Terms & Conditions and Privacy Policy to continue.
        </FormHelperText>
      )}
    </div>
  );
}
